import { FC } from 'react';
import { CommonActiveDataSource } from '../common';
import { OverviewTabProps } from '../types/types';

export const ActiveCodeDataSource: FC<OverviewTabProps> = ({ dataSource }) => {
  return dataSource ? <CommonActiveDataSource dataSource={dataSource} polling={true} /> : <div />;
};
